import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/microComponents/BackButton";
import WeekCard from "../components/WeekCard/WeekCard";
import { generateWeeks } from "../utils/weekUtils";
import scrollToTop from "../components/ScrollTop/ScrollTop";

/**
 * TopPerformer page displays 8 weekly cards
 * Users can click on a week to see top performers for that period
 */
const TopPerformer: React.FC = () => {
  const navigate = useNavigate();
  
  // Generate weeks data (memoized to avoid recalculation on every render)
  const weeks = useMemo(() => generateWeeks(), []);

  const handleWeekClick = (startDate: string, endDate: string) => {
    navigate(`/top-performer/${startDate}/${endDate}`);
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="Container pb-4 top-performer-page">
      <div className="home_container">
        <BackButton title="Top Performers" isSticky={true} />

        <div className="top-performer-content">
          <div className="top-performer-header">
            <h2>Weekly Top Performers</h2>
            <p>See who used the app the most each week</p>
          </div>

          <div className="weeks-grid">
            {weeks.map((week, index) => (
              <WeekCard
                key={`${week.startDate}-${week.endDate}`}
                week={week}
                onClick={() => handleWeekClick(week.startDate, week.endDate)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopPerformer;
